import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { api } from '../consts/url';
import { ProjectModel } from '../store/models/project.model';

@Injectable({ providedIn: 'root' })
export class ProjectService {
  constructor(private readonly http: HttpClient) {
  }

  public findOne(projectId: string): Observable<ProjectModel.ProjectDocument> {
    return this.http.get<ProjectModel.ProjectDocument>(
      api.project.crudById(projectId),
    );
  }

  public findAll(
    filters: ProjectModel.API.ListProjectsQuery,
    latestTs: number | null = null,
  ): Observable<ProjectModel.ProjectDocument[]> {
    let params = new HttpParams().set('limit', ProjectModel.PAGE_LIMIT);

    if (filters.query) {
      params = params.set('query', filters.query);
    }

    if (filters.dateFrom !== undefined) {
      params = params.set('dateFrom', String(filters.dateFrom));
    }

    if (filters.dateTo !== undefined) {
      params = params.set('dateTo', String(filters.dateTo));
    }

    if (filters.closureReason) {
      params = params.set('closureReason', filters.closureReason);
    }

    if (latestTs) {
      params = params.set('latestTs', String(latestTs));
    }

    return this.http.get<ProjectModel.ProjectDocument[]>(api.project.crud, {
      params,
    });
  }

  public create(
    payload: ProjectModel.API.CreateProjectDto,
  ): Observable<ProjectModel.ProjectDocument> {
    return this.http.post<ProjectModel.ProjectDocument>(
      api.project.crud,
      payload,
    );
  }

  public update(
    projectId: string,
    payload: ProjectModel.API.UpdateProjectDto,
  ): Observable<ProjectModel.ProjectDocument> {
    return this.http.put<ProjectModel.ProjectDocument>(
      api.project.crudById(projectId),
      payload,
    );
  }

  public close(
    projectId: string,
    payload: ProjectModel.API.CloseProjectDto,
  ): Observable<ProjectModel.ProjectDocument> {
    return this.http.put<ProjectModel.ProjectDocument>(
      api.project.closeById(projectId),
      payload,
    );
  }

  public remove(projectId: string): Observable<ProjectModel.ProjectDocument> {
    return this.http.delete<ProjectModel.ProjectDocument>(`${api.project.crudById(projectId)}`);
  }
}
